import { _get, _post } from "./methods";

export default {
  searchUsers: params => _get("/admin/meetup_credits/users", params),
  grant: ({ user_id, ...rest }) =>
    _post(`/admin/meetup_credits/users/${user_id}/grant`, rest)
};
